import React, { useEffect, useRef, useState } from "react";
import rightArrow from "../../assets/img/arrow-right.svg";
import tooltip_info_icon from "../../assets/img/tooltip_info_icon.svg";
import upload_icoon from "../../assets/img/upload_icoon.svg";
import { Link, useNavigate } from "react-router-dom";
import { CallWithAuth } from "../../action/apiActions";
import { DIAGONASTIC_TOOL, GET_USER, PRACTICE_FRAMEWORK, ADMIN_CMS_IMAGE_UPLOAD_AWS, CHANGE_PASSWORD_API_URL } from "../../action/apiPath";
import { useDispatch, useSelector } from "react-redux";
import { accountCreate } from "../../redux/action";
import { ToastContainer, toast } from 'react-toastify';
import Loading from "react-fullscreen-loading";
import axios from "axios";
import { IoCameraOutline } from "react-icons/io5";
import { showToast } from "../../util/toastHelper";
import no_userImg from "../../assets/img/no_userimg.jpg";
import { errorMessageCreate } from "../../util/custom";

const CreateAccountPage = () => {
  // const locaition = useNavigate();
  const subscription_id = localStorage.getItem("subscription_id")
  const dispatch = useDispatch()
  const fileInputRef = useRef(null);
  const [practiceFrameworks, setPracticeFrameworks] = useState([]);
  const [diagnostic_tool, setDiagnosticTool] = useState([]);

  const [isAdded, setIsAdded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [preview, setPreview] = useState(no_userImg);

  const [createAccount, setCreateAccount] = useState({
    dr_role: null,
    practice_framework_id: null,
    diagnostic_tool_id: null,
    profileImage: null,
    first_name: null,
    last_name: null,
  });

  const handleRoleChange = (e) => {
    const { name, value } = e.target;
    setCreateAccount({
      ...createAccount,
      [name]: value,
    });
  };

  const practiceFrameworksApiCall = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", PRACTICE_FRAMEWORK);
      if (response.res.data && response.res.data.statusCode === 200) {
        setPracticeFrameworks(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
    try {
      const response = await CallWithAuth("GET", DIAGONASTIC_TOOL);
      if (response.res.data && response.res.data.statusCode === 200) {
        setDiagnosticTool(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
    setIsLoading(false);

  };

  const diagonastictoolApiCall = async () => {
    // try {
    //   const response = await CallWithAuth("GET", DIAGONASTIC_TOOL);
    //   if (response.res.data && response.res.data.statusCode === 200) {
    //     setDiagnosticTool(response.res.data.data);
    //   }
    // } catch (error) {
    //   console.error("Error fetching practice frameworks:", error);
    // }
  };
  const getUserInfo = async () => {
    //  console.log(JSON.parse(localStorage.getItem('userCreateAccountInfo')));
    const userDetails = JSON.parse(localStorage.getItem('userCreateAccount'));
    const userInfo = JSON.parse(localStorage.getItem('userCreateAccountInfo'));
    console.log('userInfo', userInfo);

    if (userInfo) {
      setIsAdded(true);
      if (userDetails?.profile_image) {
        setPreview(userDetails.profile_image);
      }

      setCreateAccount((prev) => ({
        ...prev,
        dr_role: userInfo.dr_role || null,
        practice_framework_id: userInfo.practice_framework_id || null,
        diagnostic_tool_id: userInfo.diagnostic_tool_id || null,
        profileImage: userDetails?.profile_image || null, // if file is also stored
        first_name: userDetails?.first_name || null,
        last_name: userDetails?.last_name || null,
      }));
    }
  }

  useEffect(() => {
    practiceFrameworksApiCall();
    diagonastictoolApiCall();
    getUserInfo();
  }, []);

  const handleFrameworkChange = (e) => {
    setCreateAccount({
      ...createAccount,
      practice_framework_id: e.target.value,
    });
  };

  const handleDiagnosticToolChange = (e) => {
    setCreateAccount({
      ...createAccount,
      diagnostic_tool_id: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files;
    setCreateAccount({
      ...createAccount,
      file: file,
    });
  };

  const handleSubmitCreate = () => {
    toast.dismiss();
    if (!createAccount.first_name) {
      return toast.error("First name is required.", {
        autoClose: 2000,
        position: "bottom-right",
      });
    }
    if (!createAccount.last_name) {
      return toast.error("Last name is required.", {
        autoClose: 2000,
        position: "bottom-right",
      });
    }
    if (!createAccount.dr_role) {
      return toast.error("Role is required.", {
        autoClose: 2000,
        position: "bottom-right",
      })
    }
    if (!createAccount.practice_framework_id) {
      return toast.error("Practice Framework is required.", {
        autoClose: 2000,
        position: "bottom-right",
      })
    }
    if (!createAccount.diagnostic_tool_id) {
      return toast.error("Provisional Diagnostic Tool is required.", {
        autoClose: 2000,
        position: "bottom-right",
      })
    }
    // if(!createAccount.file){
    //   return toast.error("De-identified Reports is required.", {
    //     autoClose: 2000,
    //     position: "bottom-right",
    //   })
    // }
    dispatch(accountCreate(createAccount))
  }

  const selector = useSelector((state) => state.GET_CREATE_ACCOUNT_REDUCER)
  const navigate = useNavigate()
  const fetchData = async () => {
    const isTokenAvailable = localStorage.getItem('accessToken');
    if (isTokenAvailable) {
      const header = {
        headers: {
          Authorization: `Bearer ${isTokenAvailable}`,
          // add any additional headers if needed
        },
      };

      try {
        setIsLoading(true);
        const response = await axios.get(GET_USER, header);
        if (response.status === 200 || response.status === 201) {
          localStorage.setItem("userCreateAccount", JSON.stringify(response?.data?.data));
          localStorage.setItem("userCreateAccountInfo", JSON.stringify(response?.data?.data?.info));

          // ✅ Custom event dispatch 
          window.dispatchEvent(new Event("profileUpdated"));
          setIsAdded(true);

        }
        setIsLoading(false)
      } catch (err) {
        if (err.response?.status === 401) {
          localStorage.clear();
          window.location.href = "/login"
        }
        setIsLoading(false);
        console.error("Error:", err.response);
      }
    }
  };
  const handleCreateAccountEffect = () => {
    if (selector.error == null) {
      if (selector.data != null) {
        toast.success(selector.message, {
          autoClose: 2000,
          position: "bottom-right",
        })
        if (subscription_id !== null) {
          setTimeout(() => {
            navigate("/manage-patient")
          }, 1000)
        } else {
          setTimeout(() => {
            navigate("/subscription"); // Navigate after 2 seconds
          }, 1000);
        }
      }
      console.log('selector.message', selector.message);
      if (selector.message) {
        // setIsAdded(true);
        // console.log("selector.message", selector);
        fetchData();
        // localStorage.setItem("userCreateAccountInfo", JSON.stringify(response?.data?.data?.info));

      }
      toast.success(selector.message, {
        autoClose: 2000,
        position: "bottom-right",
      })
    } else {
      toast.error(selector.error, {
        autoClose: 2000,
        position: "bottom-right",
      })
    }
  }

  useEffect(() => {
    handleCreateAccountEffect()
  }, [selector])

  const triggerFileInput = () => {
    fileInputRef.current && fileInputRef.current.click();
  };

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };


  const handleProfileChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
        showToast("error", 'Only jpeg, jpg or png are allowed');
        e.target.value = '';
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        showToast("error", 'File size can not be more than 5MB');
        e.target.value = '';
        return;
      }

      const fileNameRegex = /^[a-zA-Z0-9._\-\(\) ]+$/;
      if (!fileNameRegex.test(file.name)) {
        showToast("error", "Filename contains special characters or spaces. Please rename the file.");
        e.target.value = '';
        return;
      }

      const isExecutable = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = (evt) => {
          if (evt.target.readyState === FileReader.DONE) {
            const uint = new Uint8Array(evt.target.result);
            const header = Array.from(uint).map(b => b.toString(16).padStart(2, '0')).join('');console.log(header);
  
            // 1. Check for Executables (MZ header)
            if (header.startsWith("4d5a")) return resolve(true);
  
            // 2. Verify it's actually a valid Image type
            const isPNG = header.startsWith("8950"); // .png
            const isJPEG = header.startsWith("ffd8");  // .jpg / .jpeg
  
            // If the extension says png/jpg but the bytes don't match, block it
            if (isPNG || isJPEG) {
              return resolve(false);
            }
  
            resolve(true);
          }
        };
        reader.readAsArrayBuffer(file.slice(0, 2));
      });
    
      if (isExecutable) {
        showToast("error", "File is an executable disguised as an image!");
        e.target.value = '';
        return;
      }

      setIsLoading(true);
      // Preview 
      const url = URL.createObjectURL(file);
      setPreview(url);

      try {
        const { files } = e.target;
        const file = files[0];
        const formdata = new FormData();
        formdata.append("file", file);
        const body = formdata;
        const response = await CallWithAuth("POST", ADMIN_CMS_IMAGE_UPLOAD_AWS, body);

        if (response?.res?.status === 200 || 201) {
          setPreview(response?.res?.data?.file_url);
          showToast("success", "Image uploaded successfully.");
          setCreateAccount({
            ...createAccount,
            profileImage: response?.res?.data?.file_url,
          });
        } else {
          showToast("error", '"Something went wrong!"');
        }
        setIsLoading(false);
      } catch (err) { }
      setIsLoading(false);
    }
  };

  return (
    <div>
      {(selector?.isLoading || isLoading) && (
        <Loading
          loading
          background="rgba(236, 240, 241, 0.7)"
          loaderColor="#3498db"
        />
      )}
      <section class="create_account_block">
        <div class="site_container">
          <div class="create_account_form">
            <div class="heading_block">
              <span class="tag">Account Setup</span>
              <h1>Update Your Account</h1>
              {/* <p>
                Choose your role and practice framework and create your account
              </p> */}
            </div>
            <div class="field_block">
              <label for="" className="text-center">Profile</label>
              <div className="profile-image mx-auto">
                <div className="image-container">
                  <img src={preview} alt="" />
                </div>
                <div className="uploader" style={{ cursor: "pointer" }}
                  onClick={handleIconClick}><IoCameraOutline /></div>
                {/* Hidden file input */}
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleProfileChange}
                  style={{ display: "none" }}
                />
              </div>
            </div>
            <div class="field_block">
              <label for="">Select Role</label>
              <div class="input_check_grp">
                <div class="item">
                  <input
                    type="radio"
                    name="dr_role"
                    value="psychiatrist"
                    checked={createAccount.dr_role === "psychiatrist"}
                    onChange={handleRoleChange}
                  />
                  <span>psychiatrist </span>
                </div>
                <div class="item">
                  <input
                    type="radio"
                    name="dr_role"
                    value="psychologist"
                    checked={createAccount.dr_role === "psychologist"}
                    onChange={handleRoleChange}
                  />
                  <span>psychologist </span>
                </div>
              </div>
            </div>
            <div className="field_block">
              <label htmlFor="first_name">First Name</label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                className="text_field"
                placeholder="Enter your first name"
                value={createAccount.first_name || ""}
                onChange={(e) =>
                  setCreateAccount({
                    ...createAccount,
                    first_name: e.target.value,
                  })
                }
              />

              <label htmlFor="last_name" style={{ marginTop: "10px" }}>Last Name</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                className="text_field"
                placeholder="Enter your last name"
                value={createAccount.last_name || ""}
                onChange={(e) =>
                  setCreateAccount({
                    ...createAccount,
                    last_name: e.target.value,
                  })
                }
              />
            </div>
            <div className="field_block">
              <label>Select Practice Framework</label>
              <select
                name="practice_framework"
                id="practice_framework"
                className="select1"
                onChange={handleFrameworkChange}
                value={createAccount.practice_framework_id || ""}
              >
                <option value="">Select Practice Framework</option>
                {practiceFrameworks?.map((framework) => (
                  <option key={framework.id} value={framework.id}>
                    {framework.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="field_block">
              <label>Select Provisional Diagnostic Tool</label>
              <select
                name="diagnostic_tool"
                id="diagnostic_tool"
                className="select1"
                onChange={handleDiagnosticToolChange}
                value={createAccount.diagnostic_tool_id || ""}
              >
                <option value="">Select Diagnostic Tool</option>
                {diagnostic_tool?.map((tool) => (
                  <option key={tool.id} value={tool.id}>
                    {tool.name}
                  </option>
                ))}
              </select>
            </div>
          <div class="btn_row">
            <Link to={"/"} class="outlined_cta cta_outline cta_with_icon">
              <span>Back</span>{" "}
            </Link>
            <a onClick={handleSubmitCreate} class="solid_cta cta_primary cta_with_icon">
              <span>{isAdded ? 'Update' : "Save"}</span>
            </a>
          </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CreateAccountPage;
